import moment from 'moment'
import React from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table } from 'antd'
import _ from 'lodash'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { hideLoader, showLoader } from '../../modules/actions'
import Request from '../../request'
import { connect } from 'react-redux'
import styles from '../../containers/Desk/counselling/all/styles.less'
import { RightsWrapper } from './utils'

@Form.create()
class ListUniversityFollowUp extends React.Component {
    state = {
        visible: true,
        childrenDrawer: false,
        arr: [],
        loading: false,
        inputTypes: [
            {
                tabTitle: 'Add Follow Up',
                fields: [
                    {
                        label: 'Next Follow Up Date',
                        key: 'followUpDate',
                        type: 'date',
                        required: true
                    },
                    {
                        label: 'Details',
                        key: 'details',
                        type: 'textArea',
                        rows: 10,
                        required: true
                    },
                    {
                        label: 'FollowUp Type',
                        key: 'followUpType',
                        type: 'select',
                        required: true,
                        options: ['Active', 'Didn\'t Pick up Call', 'Busy, Call Later', 'Not Interested', 'Out Of town'],
                        placeholder: 'Select followUp Type',
                        onChange: v => {
                            this.props.form.setFieldsValue({
                                followUpType: v
                            })
                        }
                    },

                    {
                        label: 'Rating *',
                        key: 'rating',
                        type: 'select',
                        options: ['Fit2Apply', 'Potential', 'Neutral', 'Cold', 'Dead', 'Active'],
                        placeholder: 'Select Rating',
                        required: this.props.universityObj.rating ? (this.props.universityObj.rating === 'not exists' ? true : false) : false,
                        hidden: this.props.universityObj.rating ? (this.props.universityObj.rating === 'not exists' ? false : true) : true,
                        onChange: v => {
                            this.props.form.setFieldsValue({
                                rating: v
                            })
                        }
                    }

                ]
            }
        ]
    }


    componentDidMount() {
        this.loadUniversityFollowUps()
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    renderStatus = (val) => {
        if (val === 'Didn\'t Pick up Call') {
            return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>
        }

        if (val === 'Out Of town') {
            return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>
        }

        if (val === 'Not Interested') {
            return <div className={styles.Potential}>{val.toUpperCase()}</div>
        }

        if (val === 'Busy, Call Later') {
            return <div className={styles.dead}>{val.toUpperCase()}</div>
        }

        if (val === 'Cold') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
        if (val === 'Active') {
            return <div className={styles.Cold}>{val.toUpperCase()}</div>
        }
    }

    loadUniversityFollowUps = async () => {
        this.setState({ loading: true });
        let { _id } = this.props.universityObj
        let response = await Request.loadUniversityFollowUps(_id);
        if (response) {
            this.setState({ arr: response.data })
        }
        this.setState({ loading: false })
    }



    showChildrenDrawer = () => {
        this.setState({
            childrenDrawer: true
        })
    }

    onChildrenDrawerClose = () => {
        this.setState({
            childrenDrawer: false
        })
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                values.universityId = this.props.universityObj._id;
                dispatch(showLoader())
                let response = await Request.addUniversityFollowUp(values)
                dispatch(hideLoader())
                if (!response.error) {
                    notification.success({
                        message: 'Success',
                        description: response.message
                    })

                    this.loadUniversityFollowUps()
                    this.onChildrenDrawerClose()

                    form.resetFields()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: response.message
                    })
                }
            }
        })
    }




    render() {
        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const column = [
            {
                title: 'Followups',
                key: 'detail',
                dataIndex: 'detail',
                render: (val, record) => {
                    return (
                        <div>
                            <div style={{ color: 'green' }}>
                                Follow Up Date : {moment(record.followUpDate).format('lll')}<br />
                                Created Date : {moment(record.createdByUser.time).format('lll')}
                                <div style={{ color: 'orange', float: 'right' }}>
                                    {' '}
                                    By ({record.createdByUser ? record.createdByUser.name : '---'})
                                </div>
                            </div>
                            <div>{record.details}</div>
                        </div>
                    )
                }
            },
            {
                title: 'FollowupsType',
                key: 'followUpType',
                dataIndex: 'followUpType',
                render: (val, record) => {
                    return this.renderStatus(val)
                }
            }
        ]

        return (
            <Drawer title={
                <div>
                    <React.Fragment>
                        Notes of {this.props.universityObj.name}{' '}
                        <RightsWrapper myRight={'FollowUps.add'}>
                            <a onClick={this.showChildrenDrawer} style={{ float: 'right', marginRight: 50 }}>
                                <Icon type={'plus'} /> Add New Follow Up
                            </a>
                        </RightsWrapper>
                    </React.Fragment>
                </div>
            }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={this.state.visible}>
                <Card>
                    <Table
                        showHeader={false}
                        dataSource={this.state.arr}
                        columns={column}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 50,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                        loading={this.state.loading}
                    />
                </Card>

                <Drawer
                    title={
                        <div>
                            <Icon type={'calendar'} />
                            NEW FOLLOW UP
                        </div>
                    }
                    width={500}
                    closable={false}
                    onClose={this.onChildrenDrawerClose}
                    visible={this.state.childrenDrawer}>
                    <Card>
                        <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                            {this.state.inputTypes.map((itype, key) => {
                                return (
                                    <div key={key}>
                                        <GetAllFormFields
                                            inputSchema={this.state.inputTypes[key]}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                    </div>
                                )
                            })}

                            <Row>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                        </Form>
                    </Card>
                </Drawer>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListUniversityFollowUp)
